import { MultipleThresholds } from './moderationFiltersTypes';

// This method is not inside moderationFiltersUtils to prevent circular dependencies with moderationFiltersConstants that caused bugs
export function createMultipleThresholds(
  publishAndModerate: number,
  requireApproval: number,
  reject: number
): MultipleThresholds {
  return {
    type: 'multiple',
    publishAndModerate,
    requireApproval,
    reject
  };
}
